var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TimelineSummaryContainer',{attrs:{"areaId":_vm.areaId,"groupId":117,"lineChartId":17,"boxPlotChartId":18,"timelineData":_vm.formattedLineData,"timelineDataStatus":_vm.lineDataStatus,"summaryData":_vm.formattedSummaryData,"summaryDataStatus":_vm.summaryDataStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }